import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { Crown, LogOut, ArrowUpRight } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <main className="crown-container py-12 md:py-20" data-testid="profile-page">
      <div className="max-w-2xl">
        <p className="font-overline mb-3">Profile</p>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight mb-12">{user.name}</h1>

        <div className="space-y-px bg-bone/10 mb-10">
          <div className="bg-espresso p-6 flex items-center gap-5">
            {user.picture ? <img src={user.picture} alt="" className="w-16 h-16 object-cover" /> : null}
            <div>
              <p className="font-overline text-ash">Email</p>
              <p className="font-serif text-xl">{user.email}</p>
            </div>
          </div>
          <div className="bg-espresso p-6">
            <p className="font-overline text-ash mb-2 flex items-center gap-2">
              <Crown size={12} strokeWidth={1.5} /> Membership
            </p>
            <p className="font-serif text-2xl text-gold">
              {user.is_premium ? "Premium Atelier" : "Free tier"}
            </p>
            {!user.is_premium && (
              <Link to="/pricing" className="font-overline text-gold mt-3 inline-flex items-center gap-1" data-testid="profile-upgrade-link">
                Upgrade <ArrowUpRight size={12} strokeWidth={1.5} />
              </Link>
            )}
          </div>
          <div className="bg-espresso p-6">
            <p className="font-overline text-ash mb-2">Analyses this month</p>
            <p className="font-serif text-2xl">
              {user.is_premium ? "Unlimited" : `${user.free_analyses_used || 0} / 3`}
            </p>
          </div>
        </div>

        <button onClick={logout} className="crown-btn-ghost" data-testid="profile-logout-btn">
          <LogOut size={14} strokeWidth={1.5} /> Sign out
        </button>
      </div>
    </main>
  );
}
